import * as React from 'react';

function SvgVideo(props) {
  return (
    <svg viewBox="0 0 42 34" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M39.75 7.17l-6 3.455V3.5c0-1.655-1.345-3-3-3H3c-1.655 0-3 1.345-3 3v27c0 1.655 1.345 3 3 3h27.75c1.655 0 3-1.345 3-3v-7.125l6 3.455c.998.576 2.25-.146 2.25-1.294V8.469a1.5 1.5 0 00-2.25-1.299zm-9.375 22.955h-27V3.875h27v26.25zm8.25-7.828l-4.875-2.803V14.51l4.875-2.808v10.594zM6.75 9.875H12a.376.376 0 00.375-.375V7.25A.376.376 0 0012 6.875H6.75a.376.376 0 00-.375.375V9.5c0 .206.169.375.375.375z" />
    </svg>
  );
}

export default SvgVideo;
